import {Injectable} from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { PermissionActions } from '../app.actions';
import { IAppState } from '../interfaces/appstate.interface';

declare var $:any;

@Injectable()
export class _UserService {

  subscription: any;

  constructor(
  private ngRedux: NgRedux<IAppState>, // <- New
  private actions: PermissionActions) { }

  login(accessToken: boolean) {
    localStorage.setItem('loggedIn', 'true')
  }

  logout() {
    document.cookie = 'SESSION=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    localStorage.removeItem('loggedIn')
    // currently a hack that will get removed when we move to oauth.
    // it exists because we can't have the interceptor and the user
    //service reference eachother
    $.ajax({url: '/api/unauthenticate', method: 'POST'})
  }

}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/user.service.ts